__turbopack_context__.v({
  "icon": "pRAkaa_icon",
  "partMoveContainer": "pRAkaa_partMoveContainer",
  "rangeContainer": "pRAkaa_rangeContainer",
});
